var render = function render() {
  var _vm$row, _vm$row2, _vm$row3, _vm$row4;
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-popover", {
    attrs: {
      placement: _vm.placement,
      trigger: _vm.trigger,
      width: _vm.width,
      "popper-class": _vm.popperClass,
      "append-to-body": _vm.appendToBody
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", [_vm.title ? _c("div", {
    staticClass: "popover-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c("div", {
    staticClass: "popover-content"
  }, [_c("div", {
    staticClass: "popover-content-item"
  }, [_c("span", {
    staticClass: "label"
  }, [_vm._v("款项流水")]), _vm._v(_vm._s(((_vm$row = _vm.row) === null || _vm$row === void 0 ? void 0 : _vm$row.receiptWaterNbr) || "") + " ")]), _c("div", {
    staticClass: "popover-content-item"
  }, [_c("span", {
    staticClass: "label"
  }, [_vm._v("回单流水")]), _c("div", {
    staticClass: "flex-item",
    class: !_vm.isTrue ? "text-red" : "red-success"
  }, [_c("p", [_vm._v(_vm._s(((_vm$row2 = _vm.row) === null || _vm$row2 === void 0 ? void 0 : _vm$row2.receiptSerialNumber) || ""))]), _c("p", {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.isTrue ? "系统识别：编号一致" : "系统识别不一致"))])])]), _c("div", {
    staticClass: "popover-content-item"
  }, [_c("span", {
    staticClass: "label"
  }, [_vm._v("回单截图")]), (_vm$row3 = _vm.row) !== null && _vm$row3 !== void 0 && _vm$row3.returnSlip ? _c("img", {
    staticClass: "popover-img",
    staticStyle: {
      width: "70px",
      height: "70px"
    },
    attrs: {
      src: ((_vm$row4 = _vm.row) === null || _vm$row4 === void 0 ? void 0 : _vm$row4.returnSlip) || "",
      alt: ""
    },
    on: {
      click: function click($event) {
        var _vm$row5;
        return _vm.previewImg(((_vm$row5 = _vm.row) === null || _vm$row5 === void 0 ? void 0 : _vm$row5.returnSlip) || "");
      }
    }
  }) : _vm._e()])]), _vm._t("content", function () {
    return [_c("div", {
      attrs: {
        slot: "content"
      },
      slot: "content"
    })];
  }), _vm._t("default")], 2), _c("div", {
    staticClass: "bottom-list"
  }, [_c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _c("ConfirmPopover", {
    ref: "confirmPopover",
    attrs: {
      title: "请二次确认是否" + (_vm.isConfirm ? "收款" : "拒绝"),
      content: "\u5F53\u524D\u7CFB\u7EDF\u8BC6\u522B\u6D41\u6C34\u7F16\u53F7".concat(_vm.isTrue ? "一致" : "不一致", "\uFF0C\u8BF7\u4E8C\u6B21\u4EBA\u5DE5\u6838\u5BF9\u540E\u786E\u8BA4\uFF01"),
      width: "240",
      disabled: _vm.isConfirm ? _vm.isTrue : !_vm.isTrue
    },
    on: {
      confirm: function confirm($event) {
        return _vm.confirmOrRefund(_vm.row);
      },
      cancel: _vm.cancel
    }
  }, [_c("el-button", {
    attrs: {
      slot: "reference",
      type: "primary",
      size: "mini"
    },
    on: {
      click: _vm.confirm
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.confirmText))])], 1)], 1), _c("div", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_vm._t("reference")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };